import React from "react";
import classNames from "classnames/bind";
import styles from "./Logo.module.scss";
import Images from "../../asset/images";
import { Link } from "react-router-dom";

const cx = classNames.bind(styles);

const Logo = ({ className }) => {
  return (
    <Link to={`/`} className={cx("logo", className)}>
      <img src={Images.logoImage} className={cx("logo__imgage")} alt="LIANNE JEWELRY" />
    </Link>
  );
};

export default Logo;
